import React, {
  useCallback,
  useMemo,
  useRef,
  useImperativeHandle,
} from 'react';

import { Input as InputItem } from 'antd';
import { parseIncompletePhoneNumber, formatIncompletePhoneNumber } from 'libphonenumber-js/core'


const Input = ({
  value,
  placeholder,
  onChange,
  onFocus,
  onBlur,
  country,
  metadata,
  inputRef,
}) => {
  const innerInputRef = useRef();

  useImperativeHandle(inputRef, () => ({
    focus: () => {
      innerInputRef.current.focus();
    }
  }));

  const format = useCallback((value) => {
    return formatIncompletePhoneNumber(value, country, metadata);
  }, [country, metadata]);

  const handleChange = useCallback((newValue) => {
    let parsedValue = parseIncompletePhoneNumber(newValue);

    if(parsedValue === value) {
      if(format(parsedValue).indexOf(newValue) === 0) {
        parsedValue = parsedValue.slice(0, -1);
      }
    }

    onChange(parsedValue);
  }, [
    format,
    onChange,
    value,
  ]);

  const formattedValue = useMemo(() => format(value), [value, format]);

  return(
    <InputItem
      placeholder={placeholder}
      className="PhoneInput-input"
      ref={innerInputRef}
      value={formattedValue}
      onChange={e => handleChange(e.target.value)}
      onFocus={onFocus}
      onBlur={onBlur}
      type="tel"
    />
  );
};


export default Input;

